"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.makeSetSearchCriteria = exports.constructSearchPhrase = exports.formatKey = exports.hasReservedChars = exports.makeSetSearchPhrase = exports.createMatchResolver = exports.classifySearchPhrase = exports.mapAssociatedTerms = exports.parseTerms = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var searchTermRegex = /((?!["'])\S+:)|[^\s",:]+|"([^"]*)"|'([^']*)'|(,)/gm;

var parseTerms = function parseTerms(phrase) {
  var terms = [];
  var match;

  while ((match = searchTermRegex.exec(phrase)) !== null) {
    if (match.index === searchTermRegex.lastIndex) {
      searchTermRegex.lastIndex++;
    }

    if (match.length > 0 && match[0]) {
      terms.push(match[0]);
    }
  }

  return terms;
};

exports.parseTerms = parseTerms;

var mapAssociatedTerms = function mapAssociatedTerms(terms, index) {
  var matches = [];
  var i = index;
  var shouldAppend = true;

  for (; i < terms.length && shouldAppend; i++) {
    var term = terms[i];

    if (!term) {
      continue;
    }

    if (term.endsWith(':')) {
      break;
    }

    var matchableTerm = term;

    if (matchableTerm.startsWith('"') && matchableTerm.endsWith('"')) {
      matchableTerm = matchableTerm.slice(1, -1);
    }

    matches.push(matchableTerm); // look ahead for a comma

    shouldAppend = i + 1 < terms.length && terms[i + 1] === ','; // skip next, its a comma

    if (shouldAppend) {
      i++;
    } else {
      // stop immediately without incrementing index
      break;
    }
  }

  return {
    index: i,
    matches: matches
  };
};

exports.mapAssociatedTerms = mapAssociatedTerms;

var classifySearchPhrase = function classifySearchPhrase(phrase) {
  var criterions = {};
  var keywords = [];
  var terms = parseTerms(phrase);

  for (var i = 0; i < terms.length; i++) {
    var term = terms[i];

    if (term && !term.endsWith(':')) {
      keywords.push(term);
      continue;
    }

    var tag = term;
    i++; // move to next after tag

    var _mapAssociatedTerms = mapAssociatedTerms(terms, i),
        matches = _mapAssociatedTerms.matches,
        index = _mapAssociatedTerms.index;

    criterions[tag] = matches;
    i = index;
  }

  return {
    keywords: keywords,
    criterions: criterions
  };
};

exports.classifySearchPhrase = classifySearchPhrase;

var createMatchResolver = function createMatchResolver(tag, criteria, terms) {
  return Promise.all(terms.map(function (term) {
    return criteria.matchOption(criteria.options, term);
  })).then(function (matches) {
    var selected = matches.filter(function (match) {
      return !!match;
    });
    criteria.setSelected(selected);
    return {
      tag: tag,
      selected: selected
    };
  });
};

exports.createMatchResolver = createMatchResolver;

var makeSetSearchPhrase = function makeSetSearchPhrase(_ref) {
  var searchMatchDebounce = _ref.searchMatchDebounce,
      setSearchMatchDebounce = _ref.setSearchMatchDebounce,
      setSearchPhraseInternal = _ref.setSearchPhraseInternal,
      setSearchCriteriaInternal = _ref.setSearchCriteriaInternal;
  return function (criterions) {
    return function (value) {
      var phrase = value || '';
      var debounceTimeout = 500; // 0.5 seconds

      if (phrase === '') {
        debounceTimeout = 0; // immediate
      }

      setSearchPhraseInternal(phrase);

      if (searchMatchDebounce !== null) {
        clearTimeout(searchMatchDebounce);
      }

      var timer = setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _classifySearchPhrase, keywords, $criterions, matchResolvers, resolvedSelections;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _classifySearchPhrase = classifySearchPhrase(phrase), keywords = _classifySearchPhrase.keywords, $criterions = _classifySearchPhrase.criterions;
                matchResolvers = Object.keys(criterions).map(function (tag) {
                  return createMatchResolver(tag, criterions[tag], $criterions[tag] || []);
                });
                _context.next = 4;
                return Promise.all(matchResolvers);

              case 4:
                resolvedSelections = _context.sent;
                setSearchCriteriaInternal({
                  keywords: keywords,
                  criterions: resolvedSelections.reduce(function (acc, _ref3) {
                    var tag = _ref3.tag,
                        selected = _ref3.selected;
                    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, tag, selected));
                  }, {})
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })), debounceTimeout);
      setSearchMatchDebounce(timer);
    };
  };
};

exports.makeSetSearchPhrase = makeSetSearchPhrase;

var hasReservedChars = function hasReservedChars(value) {
  return value.includes(',') || value.includes(' ');
};

exports.hasReservedChars = hasReservedChars;

var formatKey = function formatKey(key) {
  var stripped = key.replace(/"/gm, '');
  return hasReservedChars(stripped) ? "\"".concat(stripped, "\"") : stripped;
};

exports.formatKey = formatKey;

var criterionToSearchPhrase = function criterionToSearchPhrase(criterion) {
  return criterion.map(function (_ref4) {
    var key = _ref4.key;
    return formatKey(key);
  }).join(', ');
};

var constructSearchPhrase = function constructSearchPhrase(_ref5) {
  var keywords = _ref5.keywords,
      criterions = _ref5.criterions;
  var facetPhrase = Object.keys(criterions).reduce(function (acc, tag) {
    return criterions[tag].length > 0 ? "".concat(acc, " ").concat(tag).concat(criterionToSearchPhrase(criterions[tag])) : acc;
  }, '');
  return "".concat(keywords.join(' ')).concat(facetPhrase);
};

exports.constructSearchPhrase = constructSearchPhrase;

var makeSetSearchCriteria = function makeSetSearchCriteria(_ref6) {
  var setSearchPhraseInternal = _ref6.setSearchPhraseInternal,
      setSearchCriteriaInternal = _ref6.setSearchCriteriaInternal;
  return function (criteria) {
    setSearchPhraseInternal(constructSearchPhrase(criteria));
    setSearchCriteriaInternal(criteria);
  };
};

exports.makeSetSearchCriteria = makeSetSearchCriteria;

var withSearchState = function withSearchState(BaseComponent) {
  return function (_ref7) {
    var searchCriteria = _ref7.searchCriteria,
        setSearchCriteriaInternal = _ref7.setSearchCriteria,
        rest = _objectWithoutProperties(_ref7, ["searchCriteria", "setSearchCriteria"]);

    var $searchPhrase = constructSearchPhrase(searchCriteria);

    var _useState = (0, _react.useState)($searchPhrase),
        _useState2 = _slicedToArray(_useState, 2),
        searchPhrase = _useState2[0],
        setSearchPhraseInternal = _useState2[1];

    var _useState3 = (0, _react.useState)(null),
        _useState4 = _slicedToArray(_useState3, 2),
        searchMatchDebounce = _useState4[0],
        setSearchMatchDebounce = _useState4[1];

    (0, _react.useEffect)(function () {
      setSearchPhraseInternal($searchPhrase);
    }, [$searchPhrase]);
    var setSearchPhraseExternal = (0, _react.useMemo)(function () {
      return makeSetSearchPhrase({
        searchMatchDebounce: searchMatchDebounce,
        setSearchMatchDebounce: setSearchMatchDebounce,
        setSearchPhraseInternal: setSearchPhraseInternal,
        setSearchCriteriaInternal: setSearchCriteriaInternal
      });
    }, [searchMatchDebounce, setSearchMatchDebounce, setSearchPhraseInternal, setSearchCriteriaInternal]);
    var setSearchCriteria = (0, _react.useMemo)(function () {
      return makeSetSearchCriteria({
        setSearchCriteriaInternal: setSearchCriteriaInternal,
        setSearchPhraseInternal: setSearchPhraseInternal
      });
    }, [setSearchCriteriaInternal, setSearchPhraseInternal]);
    return /*#__PURE__*/_react["default"].createElement(BaseComponent, _extends({}, rest, {
      searchCriteria: searchCriteria,
      setSearchCriteria: setSearchCriteria,
      searchPhrase: searchPhrase,
      makeSetSearchPhrase: setSearchPhraseExternal,
      setSearchPhraseInternal: setSearchPhraseInternal
    }));
  };
};

var _default = withSearchState;
exports["default"] = _default;